export default "__VITE_ASSET__ptrzkqnb__"